import { render, staticRenderFns } from "./bannerDetail.vue?vue&type=template&id=884a29e6&"
import script from "./bannerDetail.vue?vue&type=script&lang=js&"
export * from "./bannerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports